import i18n from '../i18n'
import moment from 'moment'

export function moneyFilter (value) {
  const formatter = new Intl.NumberFormat('zh-TW', {
    style: 'currency',
    currency: 'TWD',
    // These options are needed to round to whole numbers if that's what you want.
    minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 0 // (causes 2500.99 to be printed as $2,501)
  })
  return formatter.format(value)
}

export function appointmentTimeFilter (value) {
  if (value === 0) {
    return i18n.t('order.deliver_time.now')
  }
  return moment.unix(value).format('YYYY/MM/DD HH:mm')
}

export function fromUnixToDateTimeFilter (value) {
  return moment.unix(value).format('YYYY-MM-DD HH:mm')
}

export function creditCardTypeFilter (value) {
    if (value.startsWith('4')) {
        return 'Visa'
    } else if (value.startsWith('5')) {
        const num = parseInt(value.substr(1, 2))
        if (num >= 51 && num <= 55) {
            return 'MasterCard'
        }
    } else if (value.startsWith('3')) {
        const num = parseInt(value.substr(1, 3))
        if (num >= 340 && num <= 379) {
            return 'American Express'
        } else if (num >= 528 && num <= 589) {
            return 'JCB'
        }
    }
    return ''
}
